import { ConstraintRule } from '../constraint-rule';
import {
  BookingParams,
  BookingPosition,
  ConstraintSummary,
} from '../../types';
import { disallowedReason } from '../../capabilities/booking-capabilities';

/**
 * Blockt Richtungen, die laut Capabilities-Matrix
 * (`capabilities/booking-capabilities.ts`) in der aktuellen
 * Funktionsschalter-Konfiguration nicht erlaubt sind.
 */
export class RuleDirectionAllowed extends ConstraintRule {
  /**
   * Greift immer, da jede Buchung gegen die Richtungs-Matrix zu prüfen ist.
   * @param position Zu prüfende Buchungsposition (nicht verwendet).
   * @param params Buchungsparameter (nicht verwendet).
   * @returns Immer true.
   */
  public async needsCheck(
    position: BookingPosition,
    params: BookingParams,
  ): Promise<boolean> {
    return true;
  }

  /**
   * Prüft die Richtung von Quell- zu Zieltyp gegen die Capabilities-Matrix.
   * @param position Zu prüfende Buchungsposition (nicht verwendet).
   * @param params Buchungsparameter, aus deren Kontext Quell-/Zieltyp und Systemzustand gelesen werden.
   * @returns Nicht erfüllt mit Begründung, falls die Richtung verboten ist, sonst erfüllt.
   */
  public async check(
    position: BookingPosition,
    params: BookingParams,
  ): Promise<ConstraintSummary> {
    const { booking, system } = params.context;
    const reason = disallowedReason(
      booking.sourceType,
      booking.targetType,
      system,
    );
    if (reason !== null) {
      return this.unsatisfied(reason);
    }
    return this.satisfied();
  }
}
